import {Chip} from "@/components/chip/Chip.tsx";
import {Dot} from "@/components/dot/Dot.tsx";
import {AnalyzerReportTagProps} from "@/pages/analyzer/Analyzer.types.ts";

export const AnalyzerReportTag = ({tag, className}: AnalyzerReportTagProps) => (
  <Chip variant="count" size="tinyMedium" className={className}>
    {tag.dot && <Dot variant={tag.dot} size="small" />}
    {tag.label}
  </Chip>
);
